export default function EmptyState({ message = "لا توجد بيانات" }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: 40,
        color: "#475569",
        fontSize: 14,
      }}
    >
      {message}
    </div>
  );
}
